import React, { useCallback } from "react";
import {
  CustomTab,
  CustomTabs,
  a11yProps,
} from "../FullEventSubComponents/CustomTabs";

type FlatMobileTabsProps = {
  tabValue: number;
  setTabValue: (tabValue: number) => void;
  tabNames: string[];
  onChangeTab?: (newValue: number) => void;
  containerStyles?: React.CSSProperties;
  fontStyles?: React.CSSProperties;
  spacing?: number;
};

// Used for the list tabs on mobile
export const FlatMobileTabs = (props: FlatMobileTabsProps) => {
  const {
    tabValue,
    setTabValue,
    tabNames,
    onChangeTab,
    containerStyles,
    fontStyles,
    spacing,
  } = props;

  const handleChange = useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      if (onChangeTab) {
        onChangeTab(newValue);
      }
      setTabValue(newValue);
    },
    [onChangeTab, setTabValue]
  );

  return (
    <div style={{ ...containerStyles }}>
      <CustomTabs
        value={tabValue}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons={false}
        sx={{ minHeight: 0 }}
      >
        {tabNames.map((name, index) => (
          <CustomTab
            key={index}
            label={
              <div
                className={
                  tabValue === index
                    ? "EventTabNameRowActive"
                    : "EventTabNameRow"
                }
                style={{
                  marginLeft: index === 0 ? 0 : undefined,
                  marginRight: spacing,
                }}
              >
                <span style={fontStyles} className={"TabName"}>
                  {name}
                </span>
              </div>
            }
            sx={{ minHeight: 0, cursor: "default" }}
            {...a11yProps(index)}
          />
        ))}
      </CustomTabs>
    </div>
  );
};
